export const decodeBase64Token = (encodedToken: string): string => {
  return Buffer.from(encodedToken, 'base64').toString();
};
